import { styled, lighten, darken } from "@mui/material/styles";
import { IconButton, Button } from "@mui/material";

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "effect" && prop !== "asLink" && prop !== "isMini",
})<{ effect: "add" | "edit"; asLink: boolean; isMini: boolean }>(
  ({ theme }) => ({
    transition: theme.transitions.create(["color", "backgroundColor"]),
  }),
  ({ effect, theme }) => ({
    ...(effect === "add" && {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    }),
    ...(effect === "edit" && {
      color: theme.palette.primary.main,
      width: "20px",
      height: "20px",
      borderRadius: "6px",
      fontSize: theme.typography.body2.fontSize,
    }),
  }),
  ({ asLink, theme }) => ({
    ...(asLink && {
      backgroundColor: "transparent",
      boxShadow: "none",
      // color: theme.palette.primary.main,
      textTransform: "capitalize",
      padding: "5px",
      width: "unset",
    }),
  }),
  ({ isMini, theme }) => ({
    ...(isMini && {
      //   backgroundColor:theme.palette.primary.main,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.primary.main,
      width: "20px",
      height: "20px",
      minWidth: "unset",
      padding: "3px",
      fontSize: "0.7rem",
      borderRadius: "4px",
      //   border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      "&:hover": {
        backgroundColor: lighten(theme.palette.primary.main, 0.5),
      },
    }),
  })
);

export const StyledTextButton = styled(Button)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.text.primary,
  textTransform: "capitalize",
}));
